export default __webpack_public_path__ + "static/summer_containers20-88f1b60e28db327a892cc822093433bb.webp";